module.exports = __webpack_public_path__ + "img/icon-inventario.adf548f5.svg";